<template>
    <v-container>
        <v-row>
            <v-col v-if="loadingSearch">
                <v-progress-linear color="primary" indeterminate></v-progress-linear>
            </v-col>
            <v-col v-else cols="12">
                <v-card>
                    
                    <v-row >
                        <v-col cols="12">
                            <h2 class="text-center">{{title}}</h2>
                        </v-col>
                    </v-row>

                    <v-row  class="search-container">

                        <v-col cols="12" sm="6" md="3">
                            <v-menu
                                v-model="showSearchStartDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="search.startDate ? $moment(search.startDate, $constants.DATE_PICKER_FORMAT).format($constants.DATE_FORMAT_NO_TIME) : null"
                                        label="Start Date"
                                        readonly
                                        prepend-icon="event"
                                        append-icon="close"
                                        @click:append="searchStartDateChanged(null)"
                                        v-on="on"
                                    >
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-if="showSearchStartDate"
                                    :value="search.startDate"
                                    @input="searchStartDateChanged($event)">
                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-menu
                                v-model="showSearchEndDate"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        :value="search.endDate ? $moment(search.endDate, $constants.DATE_PICKER_FORMAT).format($constants.DATE_FORMAT_NO_TIME) : null"
                                        label="End Date"
                                        readonly
                                        prepend-icon="event"
                                        append-icon="close"
                                        @click:append="searchEndDateChanged(null)"
                                        v-on="on"
                                    >
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-if="showSearchEndDate"
                                    :value="search.endDate"
                                    @input="searchEndDateChanged($event)">
                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-checkbox
                                label="Open Sessions Only"
                                v-model="search.openOnly"
                            ></v-checkbox>
                        </v-col>

                        <v-col cols="12" sm="6" md="3">
                            <v-select
                                :items="species"
                                item-text="SpeciesFullName"
                                item-value="SpeciesID"
                                v-model="search.speciesIDs"
                                label="Species"
                                clearable
                                multiple
                            ></v-select>
                        </v-col>

                        <v-col cols="12" sm="6" md="2" offset-md="3">
                            <v-btn block color="primary" :loading="loadingSessions" @click="loadSessions">Search</v-btn>
                        </v-col>

                        <v-col cols="12" sm="6" md="2">
                            <v-btn
                                v-if="!$auth.currentUserIsReadOnly()"
                                color="success"
                                block
                                @click="addSession({ Active: true })"
                            >
                                New Session
                            </v-btn>
                        </v-col>

                        <v-col cols="12" sm="6" md="2">
                            <v-btn
                                :disabled="selectedRows.length == 0"
                                color="info"
                                block
                                @click="refrigerateVenom"
                            >
                                Refrigerate Venom
                            </v-btn>
                        </v-col>

                    </v-row>

                    <v-row >
                        <v-col cols="12">
                            <template>
                                <v-row justify="center">
                                    <v-dialog
                                        v-model="deleteDialog"
                                        persistent
                                        max-width="290"
                                    >
                                        <v-card>
                                            <v-card-text class="headline">
                                                Are you sure you want to delete this session ?
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    color="accent"
                                                    @click="deleteDialog = false"
                                                >
                                                    Cancel
                                                </v-btn>
                                                <v-btn
                                                    color="info"
                                                    :loading="deleting"
                                                    @click="deleteSession(deletedSessionID)"                                              
                                                >
                                                    Confirm
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-row>
                            </template>
                            <v-data-table
                                :headers="headers"
                                :items="sessions"
                                :loading="loadingSessions"
                                :footer-props="footerProps"
                                :server-items-length="totalSessionCount"
                                :sort-by.sync="pagination.sortBy"
                                :sort-desc.sync="pagination.descending"
                                :items-per-page.sync="pagination.rowsPerPage"
                                :page.sync="pagination.page"
                                must-sort
                                show-select
                                v-model="selectedRows"
                                item-key="DailyExtractionSessionID"
                            >
                                <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
                                <template v-slot:item.SessionStartTime="{ item }" >
                                    {{item.SessionStartTime | formatDate}} 
                                </template>
                                <template v-slot:item.SessionEndTime="{ item }">
                                    {{ item.SessionEndTime | formatDate}}
                                </template>
                                <template v-slot:item.VenomRefrigeratedTime="{ item }">
                                    {{item.VenomRefrigeratedTime | formatDate}}
                                </template>
                                <template v-slot:item.SessionStartUserName="{ item }">
                                    {{item.SessionStartUserEmail | formatUserName(item.SessionStartUserFirstName, item.SessionStartUserLastName )}}
                                </template>
                                <template v-slot:item.SessionEndUserName="{ item }">
                                    {{item.SessionEndUserEmail | formatUserName(item.SessionEndUserFirstName, item.SessionEndUserLastName)}}
                                </template>
                                <template v-slot:item.VenomRefrigeratedUser="{ item }">
                                    {{item.VenomRefrigeratedUser | formatUserName(item.VenomRefrigeratedUserFirstName, item.VenomRefrigeratedUserLastName)}}
                                </template>
                                <template v-slot:item.IsInMonthlyPool="{ item }">
                                    <v-icon v-if="item.MonthlyPoolID && item.MonthlyPoolID > 0">mdi-checkbox-marked</v-icon>
                                    <v-icon v-else>mdi-checkbox-blank-outline</v-icon>
                                </template>
                                <template v-slot:item.Action="{ item }">
                                    <v-btn
                                        :color="item.IsClosed ? 'info' : 'accent'"
                                        @click="continueSession(item.DailyExtractionSessionID)"
                                    >
                                        {{item.IsClosed ? "View Session" : "Continue Session"}}
                                    </v-btn>
                                </template>
                                <template v-slot:item.Delete="{ item }">
                                    <v-btn
                                        :color="item.IsClosed ? 'info' : 'accent'"
                                        v-if="!item.IsClosed && permission"
                                        @click="showDeleteDialog(item.DailyExtractionSessionID)"
                                    >
                                        Delete Session
                                    </v-btn>
                                </template>
                                <template v-slot:item.Print="{ item }">
                                    <v-btn
                                        color="info"
                                        v-if="item.IsClosed"
                                        @click="printBarcode(item.Barcode)"
                                    >
                                        Print Barcode
                                    </v-btn>
                                </template>
                                <template v-slot:item.data-table-select="{ item, isSelected, select }">
                                    <v-simple-checkbox
                                        :value="isSelected"
                                        v-if="item.IsClosed && !item.VenomRefrigerated"
                                        @input="select($event)"
                                    ></v-simple-checkbox>
                                </template>
                                <template v-slot:header.data-table-select>
                                </template>
                                <template v-if="!loadingSessions" slot="no-data">
                                    <v-alert v-if="loadSessionsError" outlined :value="true" color="error" icon="error">
                                        {{loadSessionsError}}
                                    </v-alert>
                                    <v-alert v-if="!loadSessionsError" outlined :value="true" type="info">
                                        No results found
                                    </v-alert>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <RefrigerateVenom ref="venomFridge" @updated="loadSessions"></RefrigerateVenom>
    </v-container>
</template>

<script>

import * as VenomPoolingAPI from "@/services/venomPoolingAPI";
import RefrigerateVenom from "./RefrigerateVenom";
import util from '@/helpers/util';
import moment from 'moment';
import constants from 'comunet-btg-utah-repository-shared/constants';

export default {
    components: {
        RefrigerateVenom
    },
    props: [
        
    ],
    data() {
        return {
            search: {
                speciesIDs: [],
                openOnly: false,
                startDate: null,
                endDate: null
            },
            pagination: {
                rowsPerPage: 20, // default
                sortBy: "SessionStartTime",
                descending: true,
                page: 1
            },

            footerProps: {
                'items-per-page-options': [5, 20, 50, 100]
            },

            deleteDialog:false,
            deletedSessionID:null,
            deleting:false,

            loadingSessions: false,
            loadSessionsError: null,

            showSearchStartDate: false,
            showSearchEndDate: false,

            sessions: [],
            selectedRows: [],
            totalSessionCount: 0,
            headers: [
                {
                    text: "Session Start",
                    value: "SessionStartTime"
                },
                {
                    text: "Started By",
                    value: "SessionStartUserName"
                },
                {
                    text: "Session End",
                    value: "SessionEndTime"
                },
                {
                    text: "Ended By",
                    value: "SessionEndUserName"
                },
                {
                    text: "Venom Refrigerated Time",
                    value: "VenomRefrigeratedTime"
                },
                {
                    text: "Venom Refrigerated By",
                    value: "VenomRefrigeratedUser"
                },
                {
                    text: "Room",
                    value: "RoomName"
                },
                {
                    text: "In Monthly Pool",
                    value: "IsInMonthlyPool"
                },
                {
                    text: "", // continue / view session button
                    sortable: false,
                    value: "Action",
                    class: "min-width-column"
                },
                {
                    text: "", // print barcode
                    sortable: false,
                    value: "Print",
                    class: "min-width-column"
                },
                {
                    text: "", // delete session
                    sortable: false,
                    value: "Delete",
                    class: "min-width-column"
                }
            ]
        };
    },
    watch: {
        pagination: {
            async handler(){
                await this.loadSessions();
            },
            deep: true
        }
    },
    computed: {
        title: function() {
            return this.$route.meta.title;
        },
        permission:function(){
            return this.$store.state.authStore.user.UserProfile.Permissions.admin;
        },
        species() {
            return this.$store.state.speciesStore.species.filter(s => s.Active).sort(util.sortByField("SpeciesFullName"));
        },
        loadingSearch() {
            return this.$store.state.speciesStore.loading;
        },
        loadingData() {
            return this.loadingSessions || this.loadingSearch;
        },
    },
    methods: {
        searchStartDateChanged(newValue) {
            this.search.startDate = newValue;

            this.showSearchStartDate = false;
        },
        searchEndDateChanged(newValue) {
            this.search.endDate = newValue;

            this.showSearchEndDate = false;
        },
        showDeleteDialog(sessionID){
            this.deletedSessionID = sessionID;
            this.deleteDialog = true;
        },
        async loadSessions() {
            try {
                this.loadingSessions = true;

                this.selectedRows = [];

                const params = {
                    ...this.search,
                    ...this.pagination
                };

                if (params.startDate) {
                    params.startDate = moment(params.startDate).utc().format();
                }
                if (params.endDate) {
                    params.endDate = moment(params.endDate).utc().format();
                }

                const data = await VenomPoolingAPI.getDailyExtractionSessions(params);

                this.totalSessionCount = data.TotalSessions;
                this.sessions = data.Sessions;
            }
            catch (e) {
                this.loadSessionsError = e;
            }
            finally {
                this.loadingSessions = false;
            }
        },
        addSession() {
            this.$router.push({ name: 'dailyextractionsession'});
        },
        printBarcode(barcode) {
            let routeData = this.$router.resolve({name: 'printbarcode', params: { barcode: barcode }});
            window.open(routeData.href, '_blank');
        },
        continueSession(sessionID){
            this.$router.push({ name: 'dailyextractionsessionbyid', params: { openSessionID: sessionID }});
        },
       async deleteSession(sessionID){
            try {
                this.deleting = true;
                const data = await VenomPoolingAPI.deleteExtractionSession(sessionID);
                this.deleteDialog = false;
                this.loadSessions();
            } 
            catch (e) {
                this.loadSessionsError = e;
            }
            finally {
                this.loadingSessions = false;
                this.deleting = false;
            }
            
        },
        refrigerateVenom() {
            this.$refs.venomFridge.showDialog(this.selectedRows);
        }
    },
    created() {
        this.$store.dispatch("speciesStore/loadSpecies");

        this.loadSessions();
    },
    filters: {
        formatDate: function(value) {
            if (value){
                var date = moment(value);
                if (date.isValid){
                    return date.format(constants.DATE_FORMAT);
                } else {
                    return value;
                }
            } else {
                return "";
            }
        },
        formatUserName(email, firstname, surname){
            
            if (!email){
                return "";
            }

            var desc = "";
            if (firstname && firstname != "") {
                desc = firstname;
            }

            if (surname && surname != "") {
                desc += (desc == "" ? "" : " ") + surname;
            }
            desc += (desc == "" ? "" : " (") + email + (desc == "" ? "" : ")")

            return desc;
        },
       
    }
};
</script>

<style scoped lang="scss">
    .search-container {
        .flex {
            padding-left: 5px;
            padding-right: 5px;
        }
    }
</style>

<style>
    .min-width-column {
        width: 1%;
    }
</style>